import { Tooltip } from "@mui/material";
import noImage from "assets/images/no-image.png";
import Button from "components/common/Button";
import { useAppSelector } from "hooks/store";
import React from "react";
import { useEffect } from "react"; // === ADDED BY SAMPATH – 2026-01-14 ===
// === END SAMPATH ===
import { useState } from "react";
type Props = any;

const Product = (props: Props) => {
  const { settings, deliveryType } = useAppSelector(({ main }) => main);
  const [loading, setLoading] = useState(true);

  // === ADDED BY SAMPATH – 2026-01-14 ===
  // Always show a default image when product image is not selected
  const resolvedImageUrl =
    props?.imageUrl && String(props.imageUrl).trim() ? props.imageUrl : noImage;

  // Since we always have an image (real or default), treat as "has image" for layout
  const hasAnyImage = true;

  // Reset loading whenever image source changes (important for default image too)
  useEffect(() => {
    setLoading(true);
  }, [resolvedImageUrl]);
  // === END SAMPATH ===

  const toTitleCase = (text: string) => {
    if (!text) return "";
    return text.toLowerCase().replace(/\b([a-z])/g, (m) => m.toUpperCase());
  };

  const getDisplayPriceText = () => {
    if (settings.ApplyTakeOutDeliveryPrice !== 0) {
      if (deliveryType !== "pickup") {
        const v =
          props?.deliveryprice === 0
            ? props.price?.toFixed?.(2)
            : props?.deliveryprice?.toFixed?.(2);
        return v ? `$${v}` : "";
      }
      const v =
        props?.takeoutprice === 0
          ? props.price?.toFixed?.(2)
          : props?.takeoutprice?.toFixed?.(2);
      return v ? `$${v}` : "";
    }

    return !!props.price ? `$${props.price.toFixed(2)}` : "";
  };

  const handleCardClick = () => {
    if (typeof props.onClick === "function") props.onClick();
  };

  const handleCardKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleCardClick();
    }
  };

  // === ADDED BY SAMPATH – 2026-01-07 ===
  // Force the + button to be a PERFECT 360° circle (equal width/height + hard rounded)

  //button color set theam + button
  // const plusBtnClassName =
  // "inline-flex items-center justify-center !rounded-full w-10 h-10 p-0 " +
  //  "border border-transparent bg-[#e4e5e5] shadow-sm hover:shadow-md hover:bg-[#d9dada] " +
  // "disabled:border-gray-200 disabled:bg-gray-200 disabled:text-gray-500";

  const plusBtnClassName =
    "inline-flex items-center justify-center !rounded-full w-5 h-10 p-0 " +
    "border border-transparent bg-[#fff] shadow-md hover:shadow-sm hover:bg-[#edf0f0] " +
    "disabled:border-gray-200 disabled:bg-gray-200 disabled:text-gray-500";

  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-14 ===
  // NEW: Move (+) button to RIGHT-BOTTOM over the image area (no extra margin / like screenshot)
  const showPlusButtonOnImageCorner = true;

  // Use theme color + transparency (falls back safely if theme vars not present)
  const plusBtnCornerStyle = {
    backgroundColor: "rgba(var(--color-card, 255,255,255), 0.92)",
    border: "1px solid rgba(var(--color-primary, 0,0,0), 0.10)",
    color: "rgb(var(--color-primary, 0,0,0))",
  } as React.CSSProperties;

  const plusBtnCornerClassName =
    "inline-flex items-center justify-center !rounded-full w-10 h-10 p-0 " +
    "shadow-md hover:shadow-sm active:scale-[0.98] " +
    "disabled:opacity-60";
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // Put "LARGE: $3.00" (pricedesc) at the BOTTOM, and move Price/+ button to TOP (under description)
  const showPriceDescUnderDescription = true;
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // Remove aria-label block background/border, and force font color to #232121d9
  const priceDescStyle = {
    backgroundColor: "transparent",
    border: "none",
    color: "#232121ff",
  } as React.CSSProperties;
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // Remove ANY padding and align pricedesc to the LEFT (same start as Price)
  const priceDescContainerStyle = {
    padding: 0,
    margin: 0,
    backgroundColor: "transparent",
    border: "none",
  } as React.CSSProperties;
  // === END SAMPATH ===

  return (
    <div
      //Border Square / Grid Border Current 5
      className="bg-white shadow-sm hover:shadow-md transition-shadow w-full overflow-hidden border border-gray-500 rounded-[4px] flex flex-row items-stretch h-full min-h-[140px] cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
      role="button"
      tabIndex={0}
      onClick={handleCardClick}
      onKeyDown={handleCardKeyDown}
      aria-label={`Open ${props.productName}`}
    >
      {/* === ADDED BY SAMPATH – 2026-01-12 === */}
      {/* Remove right padding so image can attach to the card edge (no separate box look) */}
      <div className="flex flex-1 flex-row pl-4 pr-0 py-1 h-full">
        {/* === END SAMPATH === */}
        <div className="flex-1 flex flex-col h-full">
          <div className="flex flex-col min-h-0">
            <div
              // === ADDED BY SAMPATH – 2026-01-12 ===
              // FIX: ensure row uses full height so image column can stretch with content (prevents bottom gap)
              className={`flex w-full gap-3 min-h-[72px] justify-between items-stretch ${
                hasAnyImage ? "" : "items-stretch"
              }`}
              // === END SAMPATH ===
            >
              <div className={`min-w-0 flex-1 ${hasAnyImage ? "" : "relative"}`}>
                <div className="flex flex-col h-full min-h-[72px]">
                  <Tooltip title={props.productName}>
                    <h3 className="font-semibold text-base md:text-lg mb-1 text-itemColor line-clamp-2 min-w-0">
                      {props.productName}
                    </h3>
                  </Tooltip>

                  <Tooltip title={props.productDescription}>
                    <p
                      className={`text-xs md:text-sm text-gray-600 break-words whitespace-pre-line ${
                        // === ADDED BY SAMPATH – 2026-01-14 ===
                        // Always clamp like "image mode" because we always show default image too
                        hasAnyImage ? "line-clamp-2" : "line-clamp-3"
                        // === END SAMPATH ===
                      }`}
                    >
                      {toTitleCase(props.productDescription || "")}
                    </p>
                  </Tooltip>

                  <div
                    className={`pt-2 w-full flex items-center gap-3 ${
                      // === ADDED BY SAMPATH – 2026-01-14 ===
                      // No need for extra right padding because + button is no longer absolute when no image
                      hasAnyImage ? "" : "pr-14"
                      // === END SAMPATH ===
                    }`}
                  >
                    {!!getDisplayPriceText() && (
                      <span className="text-sm md:text-base font-semibold text-gray-900">
                        {getDisplayPriceText()}
                      </span>
                    )}

                    {/* === ADDED BY SAMPATH – 2026-01-14 === */}
                    {/* Keep old (+) position available, but disable when using image-corner button */}
                    {!showPlusButtonOnImageCorner && (
                      <Button
                        className={`${plusBtnClassName} ml-auto`}
                        style={{ color: "#000" }}
                        aria-label={`Add ${props.productName} to cart`}
                        onClick={(e: any) => {
                          e?.stopPropagation?.();
                          if (typeof props.onClick === "function") props.onClick();
                        }}
                      >
                        <span className="text-[20px] leading-none font-semibold text-black text-gray-900">
                          +
                        </span>
                      </Button>
                    )}
                    {/* === END SAMPATH === */}
                  </div>

                  {showPriceDescUnderDescription &&
                    props.pricedesc &&
                    props.pricedesc !== "0" && (
                      <div className="mt-auto" style={priceDescContainerStyle}>
                        <Tooltip
                          title={
                            props.pricedesc && props.pricedesc !== "0"
                              ? props.pricedesc
                              : `$${props.price}`
                          }
                        >
                          <p
                            className="text-xs md:text-sm break-words line-clamp-2 normal-case whitespace-pre-line"
                            style={{
                              color: priceDescStyle.color,
                              margin: 0,
                              padding: 0,
                            }}
                          >
                            {props.pricedesc && props.pricedesc !== "0"
                              ? props.pricedesc
                              : `$${props.price}`}
                          </p>
                        </Tooltip>
                      </div>
                    )}
                </div>
              </div>

              {/* === ADDED BY SAMPATH – 2026-01-14 === */}
              {/* Always render image column; if no product image, show default noImage */}
              <div className="w-[110px] md:w-[130px] flex-shrink-0 relative overflow-hidden self-stretch h-[calc(100%+0.5rem)] -my-1">
                {/* === ADDED BY SAMPATH – 2026-01-14 === */}
                {/* NEW: (+) button on RIGHT-BOTTOM corner over the image (image behind button) */}
                {showPlusButtonOnImageCorner && (
                  <div className="absolute right-2 bottom-2 z-20">
                    <Button
                      className={plusBtnCornerClassName}
                      style={plusBtnCornerStyle}
                      aria-label={`Add ${props.productName} to cart`}
                      onClick={(e: any) => {
                        e?.stopPropagation?.();
                        if (typeof props.onClick === "function") props.onClick();
                      }}
                    >
                      <span className="text-[20px] leading-none font-semibold">
                        +
                      </span>
                    </Button>
                  </div>
                )}
                {/* === END SAMPATH === */}

                <div className="relative h-full min-h-[140px]">
                  {loading && (
                    <div className="absolute inset-0 bg-gray-50 flex items-center justify-center">
                      <div className="w-10 h-10 border-4 border-gray-300 border-t-primary rounded-full animate-spin"></div>
                    </div>
                  )}

                  <img
                    src={resolvedImageUrl}
                    className={`${
                      loading ? "opacity-0" : "opacity-100"
                    } absolute inset-0 w-full h-full object-cover transition-opacity`}
                    onLoad={() => setLoading(false)}
                    onError={(e) => {
                      e.currentTarget.src = noImage;
                      setLoading(false);
                    }}
                    alt=""
                  />
                </div>
              </div>
              {/* === END SAMPATH === */}
            </div>

            {!showPriceDescUnderDescription &&
              props.pricedesc &&
              props.pricedesc !== "0" && (
                <div className="mt-2" style={priceDescContainerStyle}>
                  <Tooltip
                    title={
                      props.pricedesc && props.pricedesc !== "0"
                        ? props.pricedesc
                        : `$${props.price}`
                    }
                  >
                    <p
                      className="text-xs md:text-sm break-words line-clamp-2 normal-case whitespace-pre-line"
                      style={{
                        color: priceDescStyle.color,
                        margin: 0,
                        padding: 0,
                      }}
                    >
                      {props.pricedesc && props.pricedesc !== "0"
                        ? props.pricedesc
                        : `$${props.price}`}
                    </p>
                  </Tooltip>
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
